import { useCallback, useEffect, useMemo } from 'react';
import { useDispatch } from 'react-redux';

import { formatTimerToMmSs } from 'shared/lib';

import {
  getRetryTimerSecondsLeftThunk,
  setSmsRetryTimerIsRunning,
  updateRetryTimerSecondsLeft,
  useRetryTimerIsRunning,
  useRetryTimerSecondsLeft,
} from 'entities/preApprovals';

export const useCountdownTimer = () => {
  const secondsLeft = useRetryTimerSecondsLeft();
  const isRunning = useRetryTimerIsRunning();
  const dispatch = useDispatch();

  const startTimer = useCallback(() => {
    dispatch(setSmsRetryTimerIsRunning(true));
  }, [dispatch]);

  const resetTimer = useCallback(() => {
    dispatch(setSmsRetryTimerIsRunning(false));
    dispatch(updateRetryTimerSecondsLeft(0));
  }, [dispatch]);

  useEffect(() => {
    if (!isRunning) return;

    const id = setInterval(() => {
      const timeLeft = dispatch(getRetryTimerSecondsLeftThunk()) as unknown as number;
      const next = timeLeft > 0 ? timeLeft - 1 : 0;

      dispatch(updateRetryTimerSecondsLeft(next));

      if (next <= 0) {
        dispatch(setSmsRetryTimerIsRunning(false));
        clearInterval(id);
      }
    }, 1000);

    return () => clearInterval(id);
  }, [dispatch, isRunning]);

  const retryTimerText = useMemo(() => formatTimerToMmSs(secondsLeft), [secondsLeft]);

  return {
    secondsLeft,
    retryTimerText,
    startTimer,
    resetTimer,
  };
};
